/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dns_Config_RequiredInputs */

const en_dns_config_required = /** @type {(inputs: Dns_Config_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DNS Config Required`)
};

const es_dns_config_required = /** @type {(inputs: Dns_Config_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se requiere configuración DNS`)
};

const fr_dns_config_required = /** @type {(inputs: Dns_Config_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configuration DNS requise`)
};

const de_dns_config_required = /** @type {(inputs: Dns_Config_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DNS-Konfiguration erforderlich`)
};

const ja_dns_config_required = /** @type {(inputs: Dns_Config_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DNS設定が必要です`)
};

const zh_dns_config_required = /** @type {(inputs: Dns_Config_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`需配置 DNS`)
};

const ar_dns_config_required = /** @type {(inputs: Dns_Config_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تكوين DNS مطلوب`)
};

const id_dns_config_required = /** @type {(inputs: Dns_Config_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konfigurasi DNS Diperlukan`)
};

const it_dns_config_required = /** @type {(inputs: Dns_Config_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configurazione DNS Richiesta`)
};

const ru_dns_config_required = /** @type {(inputs: Dns_Config_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Требуется настройка DNS`)
};

const pt_dns_config_required = /** @type {(inputs: Dns_Config_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configuração de DNS Obrigatória`)
};

const ko_dns_config_required = /** @type {(inputs: Dns_Config_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DNS 구성 필요`)
};

/**
* | output |
* | --- |
* | "DNS Config Required" |
*
* @param {Dns_Config_RequiredInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const dns_config_required = /** @type {((inputs?: Dns_Config_RequiredInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dns_Config_RequiredInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dns_config_required(inputs)
	if (locale === "es") return es_dns_config_required(inputs)
	if (locale === "fr") return fr_dns_config_required(inputs)
	if (locale === "de") return de_dns_config_required(inputs)
	if (locale === "ja") return ja_dns_config_required(inputs)
	if (locale === "zh") return zh_dns_config_required(inputs)
	if (locale === "ar") return ar_dns_config_required(inputs)
	if (locale === "id") return id_dns_config_required(inputs)
	if (locale === "it") return it_dns_config_required(inputs)
	if (locale === "ru") return ru_dns_config_required(inputs)
	if (locale === "pt") return pt_dns_config_required(inputs)
	return ko_dns_config_required(inputs)
});